import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 24px 12px 32px;
  }
`;

export const Header = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 24px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 24px 16px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 16px;
  margin-left: auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ActionButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &.primary {
    background: #34574A;
    color: white;
    border: none;

    &:hover {
      background: #2a4539;
    }
  }

  &.secondary {
    background: white;
    border: 2px solid #34574A;
    color: #34574A;

    &:hover {
      background: #f8f9fa;
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const AgencySelector = styled.div`
  background: white;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }

  select {
    padding: 8px 16px;
    border: 2px solid #eee;
    border-radius: 6px;
    font-size: 0.875rem;
    min-width: 200px;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: #34574A;
    }
  }
`;

export const AgencyLogo = styled.div`
  width: 120px;
  height: 120px;
  background: #34574A;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  font-weight: 500;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;

export const AgencyInfo = styled.div`
  flex: 1;

  h1 {
    font-size: 1.75rem;
    color: #333;
    margin: 0 0 8px 0;

    @media (max-width: 768px) {
      font-size: 1.5rem;
      word-break: break-word;
    }
  }

  .description {
    color: #666;
    margin-bottom: 16px;
    word-break: break-word;

    @media (max-width: 768px) {
      font-size: 0.95rem;
      text-align: center;
    }
  }

  .meta {
    display: flex;
    gap: 24px;
    color: #666;
    font-size: 0.875rem;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .item {
      display: flex;
      align-items: center;
      gap: 8px;

      @media (max-width: 768px) {
        text-align: center;
        justify-content: center;
        word-break: break-word;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
`;

export const StatCard = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .title {
    font-size: 0.875rem;
    color: #666;
    margin-bottom: 8px;
  }

  .value {
    font-size: 2rem;
    color: #333;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .trend {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;

    &.positive {
      color: #1e7e34;
    }

    &.negative {
      color: #c62828;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const Section = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 1.5px solid #e0e0e0;
  background: #f7fafc;
  margin-bottom: 24px;
  box-shadow: 0 1px 6px #34574A08;
  border-radius: 12px 12px 0 0;
  overflow-x: auto;
`;

export const SectionHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 12px;

  h2 {
    font-size: 1.35rem;
    color: #34574A;
    margin: 0;
    font-weight: 800;
  }
`;


export const Tab = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: 14px 28px;
  border-bottom: 2px solid ${props => props.active ? '#34574A' : 'transparent'};
  color: ${props => props.active ? '#34574A' : '#666'};
  font-size: 0.975rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  margin-right: 8px;
  border-radius: 0;
  position: relative;

  &:hover {
    color: #34574A;
    background: #f0f7f4;
  }
`;

export const ChartContainer = styled.div`
  padding: 24px;
  height: 300px;
  position: relative;
  background: #f7fafc;
  border-radius: 18px;
  box-shadow: 0 1px 8px #34574A08;
  margin-bottom: 0;

  .placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #bdbdbd;
    font-size: 1.13rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

export const TeamMember = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px #34574A11;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 12px;
  opacity: ${props => (props.$inactive ? 0.55 : 1)};
  filter: ${props => (props.$inactive ? 'grayscale(0.15)' : 'none')};
  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #34574A;
    color: #fff;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-right: 16px;
  }
  .info {
    flex: 1;
    .name {
      font-weight: 700;
      font-size: 1.1rem;
      color: #34574A;
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }
    .status-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #c62828;
      color: #fff;
      border-radius: 999px;
      padding: 2px 10px;
      font-size: 0.82rem;
      font-weight: 700;
      line-height: 1;
    }
    .role {
      color: #888;
      font-size: 0.97rem;
      margin-bottom: 8px;
    }
    .stats {
      display: flex;
      gap: 12px;
      margin-top: 4px;
    }
  }
`;